import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=2e9796f9&scoped=true"
import script from "./empty.vue?vue&type=script&lang=ts"
export * from "./empty.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./empty.vue?vue&type=style&index=0&id=2e9796f9&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2e9796f9",
  "6af48e8e"
  
)

export default component.exports